import React, { useState } from 'react';

export interface AttachmentViewer {
  activeAttachmentImage: string;
  setActiveAttachmentImage: (attachmentURI: string) => void;
}

export const AttachmentViewerContext =
  React.createContext<AttachmentViewer | null>(null);

export const AttachmentViewerProvider: React.FC = ({ children }) => {
  const [activeAttachmentImage, setActiveAttachmentImage] = useState<string>();
  const value = {
    activeAttachmentImage,
    setActiveAttachmentImage,
  };
  return (
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    <AttachmentViewerContext.Provider value={value}>
      {children}
    </AttachmentViewerContext.Provider>
  );
};
